import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/lib/i18n";
import { AuthProvider } from "@/context/AuthContext";
import Home from "@/pages/Home";
import RequestPage from "@/pages/RequestPage";
import CheckStatus from "@/pages/CheckStatus";
import Volunteer from "@/pages/Volunteer";
import Privacy from "@/pages/Privacy";
import Login from "@/pages/staff/Login";
import StaffLayout from "@/pages/staff/StaffLayout";
import Dashboard from "@/pages/staff/Dashboard";
import Cases from "@/pages/staff/Cases";
import CaseDetail from "@/pages/staff/CaseDetail";
import Intake from "@/pages/staff/Intake";
import Reports from "@/pages/staff/Reports";
import Users from "@/pages/staff/Users";
import Gkks from "@/pages/staff/Gkks";
import AuditLog from "@/pages/staff/AuditLog";
import Volunteers from "@/pages/staff/Volunteers";
import Procedures from "@/pages/staff/Procedures";
import ChangePassword from "@/pages/staff/ChangePassword";
import Trash from "@/pages/staff/Trash";
import Settings from "@/pages/staff/Settings";
import Visits from "@/pages/staff/Visits";
import Survey from "@/pages/staff/Survey";
import VisitPrint from "@/pages/staff/VisitPrint";
import RequirePerm from "@/components/staff/RequirePerm";

function App() {
  return (
    <div className="App">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/request/:type" element={<RequestPage />} />
              <Route path="/check" element={<CheckStatus />} />
              <Route path="/help" element={<Volunteer />} />
              <Route path="/privacy" element={<Privacy />} />
              <Route path="/office/login" element={<Login />} />
              <Route path="/office" element={<StaffLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="cases" element={<Cases />} />
                <Route path="cases/:id" element={<CaseDetail />} />
                <Route path="intake" element={<Intake />} />
                <Route path="reports" element={<Reports />} />
                <Route path="volunteers" element={<Volunteers />} />
                <Route path="users" element={<RequirePerm perm="users:manage"><Users /></RequirePerm>} />
                <Route path="gkks" element={<RequirePerm perm="gkk:manage"><Gkks /></RequirePerm>} />
                <Route path="audit" element={<RequirePerm perm="audit:read"><AuditLog /></RequirePerm>} />
                <Route path="procedures" element={<Procedures />} />
                <Route path="password" element={<ChangePassword />} />
                <Route path="trash" element={<Trash />} />
                <Route path="settings" element={<RequirePerm perm="users:manage"><Settings /></RequirePerm>} />
                <Route path="visits" element={<Visits />} />
                <Route path="visits/print" element={<VisitPrint />} />
                <Route path="survey" element={<Survey />} />
              </Route>
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <div className="no-print"><Toaster position="top-center" richColors /></div>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
